var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1848 1.8761V5.62827M6.68045 1.8761V5.62827M1.99023 9.38044H18.875M3.86632 3.75219H16.9989C18.0351 3.75219 18.875 4.59214 18.875 5.62827V18.7609C18.875 19.797 18.0351 20.637 16.9989 20.637H3.86632C2.83019 20.637 1.99023 19.797 1.99023 18.7609V5.62827C1.99023 4.59214 2.83019 3.75219 3.86632 3.75219Z",
    stroke: "white",
    strokeWidth: 2.2513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.660cc5900ea1b91d73e461f669953fa5.svg";
export { ForwardRef as ReactComponent };